import type { FC } from 'react';

import { ErrorMessageStyled } from './ErrorMessage.styled';

export type ErrorMessagePropsT = {
  error: string;
};

const ErrorMessage: FC<ErrorMessagePropsT> = ({ error }) => (
  <ErrorMessageStyled role="alert" color="error" size="sm">
    {error}
  </ErrorMessageStyled>
);

export default ErrorMessage;
